export default "__VITE_ASSET__BtRv0FYr__"